import { Component } from '@angular/core';

@Component({
    selector: 'layout-intermediario',
    templateUrl: './layout.component.html',
    standalone: false
})
export class LayoutComponent{}